import { SectionHeading } from '@/features/invoice_reports/components/InvoiceReportDetailDrawer/components/SectionHeading';
import { useTranslation } from '@/i18n';
import { FC, memo } from 'react';
import { JournalInfoTableView } from './Table';

type JournalInfoProps = { reportId: string };

export const JournalInfo: FC<JournalInfoProps> = memo(({ reportId }) => {
  const { t } = useTranslation();

  return (
    <SectionHeading title={t('journal_entry.section_title')}>
      <JournalInfoTableView reportId={reportId} />
    </SectionHeading>
  );
});
JournalInfo.displayName = 'JournalInfo';
